import EventParticipationStatus from 'app/frontend/types/custom/EventParticipationStatus'
import {
  Ban,
  Check,
  Clock4,
  HelpCircle,
  PauseCircle,
  Trash2,
  X,
} from 'lucide-react'

const EventStatusIcon = ({ status }: { status: EventParticipationStatus }) => {
  const Icon = {
    absent: X,
    present: Check,
    tentative: HelpCircle,
    late: Clock4,
    standby: PauseCircle,
    missing: Ban,
    removed: Trash2,
    unknown: HelpCircle,
  }[status]

  const color = {
    absent: 'text-destructive-foreground',
    present: 'text-success-foreground',
    tentative: 'text-warning-foreground',
    late: 'text-warning-foreground',
    standby: 'text-info-foreground',
    missing: 'text-destructive-foreground',
    removed: 'text-muted-foreground',
    unknown: 'text-destructive-foreground',
  }[status]

  return <Icon className={`w-4 h-4 ${color}`} />
}

export default EventStatusIcon
